import { IUserCreateServiceProps } from "interfaces/User";
import {
  ManyUserColumnsTypes,
  userRolesIds,
} from "components/Modals/StepRegister/StepRegisterManyUser/data";

export type XlsxData = { [key in ManyUserColumnsTypes]: string };

function getScheduleDateObject(hourString: string): Date {
  const regex = /^(\d{1,2})h(\d{2})$/;
  const match = regex.exec(hourString);

  const hour = parseInt(match![1], 10);
  const minute = parseInt(match![2], 10);

  const date = new Date();
  date.setHours(hour, minute, 0, 0);

  return date;
}

class CreateManyUserAdapter {
  adapt(xlsxData: XlsxData[]): IUserCreateServiceProps[] {
    return xlsxData.map((xlsxRow) => {
      const baseObject: IUserCreateServiceProps = {
        cpf: xlsxRow["cpf_do_usuario"].replace(
          /[-.,/#!$%^&*;:{}=\-_`~()]/g,
          ""
        ),
        rg: xlsxRow["rg_do_usuario"].replace(/[-.,/#!$%^&*;:{}=\-_`~()]/g, ""),
        email: xlsxRow["email_do_usuario"],
        name: xlsxRow["nome_do_usuario"],
        password: xlsxRow["senha_do_usuario"],
        role: userRolesIds[
          xlsxRow["cargo_do_usuario"] as keyof typeof userRolesIds
        ],
        schedule:
          !!xlsxRow["tem_agenda_definida"] ||
          xlsxRow["tem_agenda_definida"].toLowerCase().trim() === "sim",
        mondayEntry: getScheduleDateObject(
          xlsxRow["horario_entrada_segunda_feira"]
        ),
        mondayExit: getScheduleDateObject(
          xlsxRow["horario_saida_segunda_feira"]
        ),
        tuesdayEntry: getScheduleDateObject(
          xlsxRow["horario_entrada_terca_feira"]
        ),
        tuesdayExit: getScheduleDateObject(
          xlsxRow["horario_saida_terca_feira"]
        ),
        wednesdayEntry: getScheduleDateObject(
          xlsxRow["horario_entrada_quarta_feira"]
        ),
        wednesdayExit: getScheduleDateObject(
          xlsxRow["horario_saida_quarta_feira"]
        ),
        thursdayEntry: getScheduleDateObject(
          xlsxRow["horario_entrada_quinta_feira"]
        ),
        thursdayExit: getScheduleDateObject(
          xlsxRow["horario_saida_quinta_feira"]
        ),
        fridayEntry: getScheduleDateObject(
          xlsxRow["horario_entrada_sexta_feira"]
        ),
        fridayExit: getScheduleDateObject(xlsxRow["horario_saida_sexta_feira"]),
        saturdayEntry: getScheduleDateObject(xlsxRow["horario_entrada_sabado"]),
        saturdayExit: getScheduleDateObject(xlsxRow["horario_saida_sabado"]),
        sundayEntry: getScheduleDateObject(xlsxRow["horario_entrada_domingo"]),
        sundayExit: getScheduleDateObject(xlsxRow["horario_saida_domingo"]),
      };

      return baseObject;
    });
  }
}

export const createManyUserAdapter = new CreateManyUserAdapter();
